// Show block based on URL parameter

// Function to get URL parameter
function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

// Get the 'show-block' parameter from the URL
var showBlock = getUrlParameter('show-block');

// Hide all blocks that contain "show-block-" in their class
var allBlocks = document.querySelectorAll('[class*="show-block-"]');
for (var i = 0; i < allBlocks.length; i++) {
  allBlocks[i].classList.add('hide-block');
}

// If the parameter is found, remove the 'hide-block' class from the matching block
if (showBlock) {
  var blockClass = 'show-block-' + showBlock;
  var blocksToShow = document.getElementsByClassName(blockClass);
  for (var j = 0; j < blocksToShow.length; j++) {
    blocksToShow[j].classList.remove('hide-block');
  }
}
